<script setup lang="ts">
  import { Badge } from "@ui-kit";
  import { ProductMiniCard } from "@src/components";
  import { type Good } from "./state";

  const {
    image_url = "",
    title = "",
    article = "",
    color = "",
    goodList = [],
  } = defineProps<{
    image_url: string;
    title: string;
    article: string;
    color: string;
    goodList: Good[];
  }>();
</script>

<template>
  <div class="order-card-item-created">
    <ProductMiniCard :image="image_url" :name="title" :article="article" :color="color" />
    <div class="good-list">
      <Badge
        v-for="good in goodList"
        :key="good.item.item_id"
        variant="primary"
        :label="`${good.item.size.toUpperCase() ?? '-'} - ${good.quantity} ${$t('шт')}.`"
      />
    </div>
  </div>
</template>

<style scoped>
  .order-card-item-created {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 12px;
    border-radius: 16px;
    background-color: var(--sf-base-background-white);

    .good-list {
      display: flex;
      gap: 4px;
      flex-wrap: wrap;
    }
  }
</style>
